export default "__VITE_ASSET__CWs_nZDH__"